export const tac = {
  requested: 'TAC has been requested',
  timestamp: 'TAC has been sent ',
  timestamp2: 'on {timestamp}',
  placeholder: 'Enter TAC',
  confirm: 'Confirm',
  notReceive: "Didn't receive TAC?",
  resendTac: 'Resend TAC',
  timerTitle: 'Time',
  invalid: 'Invalid TAC',
  beforeRequest: 'Please confirm your transfer details.',
  description: 'To proceed with this payment, please request and insert your {TAC} number',
  tooltip: {
    title:
      "What is TAC?<br/><br/>A Transaction Authorization Code(TAC)/SMS Token is a unique code that is sent to your registered mobile number, as and when requested. It provides an additional layer of security and identity authentication before you are able to perform any tasks or transactions online. Each TAC will expire after 10 minutes or upon logout, whichever is earlier.<br/><br/>Just as long as you don't give away your TAC request code, rest assured that your online transactions are secured.",
  },
};
